import { TableTitles } from "@/constants";
import { useDeleteUser, useGetAllMeditators } from "@/hooks/query-hooks/useMeditators";
import { Divider, Input, Space } from "antd";
import { useState } from "react";
import { Helmet } from 'react-helmet-async';
import { AnimatedComponent, DeleteConfirmationModal, PageTitle } from "../common";
import { AddNewMeditator } from "./AddNewMeditator";
import { EditMeditatorModal } from "./EditMeditatorModal";
import { RegistrantTable } from "./RegistrantTable";

export function Meditators() {

    const [keyword, setKeyword] = useState<string | null>(null);
    const { data } = useGetAllMeditators(1, 10, {
        enabled: !keyword,
        refetchOnMount: true,
    });

    const totalMeditators = data?.totalElements || 10;

    const { data: meditatorsData, isLoading: isMeditatorsLoading } = useGetAllMeditators(1, totalMeditators, {
        enabled: !!totalMeditators,
        refetchOnMount: true,
    });

    const meditators = meditatorsData ? (keyword !== null ? meditatorsData?.content?.filter((meditator) => meditator.user.name.toLowerCase().includes(keyword.toLowerCase()) || meditator.user.book?.bookNo.toLowerCase().includes(keyword.toLowerCase())) : meditatorsData?.content) : [];

    const renderColumnKeys = [
        TableTitles.registrant_name,
        TableTitles.retreat_level,
        TableTitles.registrant_book_id,
        TableTitles.registrant_phone,
        TableTitles.registrant_nrc,
        TableTitles.registrant_address,
        TableTitles.action
    ]

    return (
        <AnimatedComponent>
            <Helmet>
                <title>ယောဂီ စာရင်း</title>
            </Helmet>
            <div
                className="flex items-center justify-between"
            >
                <PageTitle>
                    ယောဂီ စာရင်း
                </PageTitle>
                <AddNewMeditator />
            </div>
            <Divider />
            <div
                className="space-y-4"
            >
                <Input.Search
                    placeholder="စာအုပ်အမှတ် (သို့) အမည် ဖြင့်ရှာရန်"
                    allowClear
                    size="large"
                    className="!w-80"
                    onSearch={(value) => setKeyword(value || null)}
                    onClear={() => setKeyword(null)}
                />

                <RegistrantTable
                    dataSource={meditators}
                    loading={isMeditatorsLoading}
                    renderColumnKeys={renderColumnKeys}
                    TableActionComponent={TableActionComponent}
                    pagination={{
                        pageSize: data?.size || 10,
                    }}
                    hasFilter={{
                        level: true
                    }}
                />
            </div>
        </AnimatedComponent >
    )
}

const TableActionComponent = ({ record }: { record: MeditatorWithMeditationRetreat }) => {

    const { mutate, isMutating } = useDeleteUser();

    return (
        <Space>
            <EditMeditatorModal
                meditator={record.user}
            />
            <DeleteConfirmationModal
                onDelete={() => mutate(record.user.id)}
                isDeleting={isMutating}
                title="ယောဂီကို ဖျက်ရန်"
                description="ယောဂီကို ဖျက်လိုပါသလား။ ယောဂီ၏ စာရင်းမှ ဖျက်သွားမည်ဖြစ်သည်။"
            />
        </Space>
    )
}